import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';
import { Ocorrencia } from '../models/Ocorrencia';

import { TiposIrregularidadesService } from './tipos-irregularidades-service';
/*
  Generated class for the OcorrenciasService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class OcorrenciasService {
  private ocorrencia: Ocorrencia;

  constructor(http: HttpClient,
    public tiposIrregularidadesService: TiposIrregularidadesService,
    private utilService: UtilService) {
  }

  /*================================================================
  *
  *  Ocorrência
  *
  ==================================================================*/

  private ocorrenciaVaziaJson = {
    "idOcorrencia": 0,
    "idPca": 0,
    "classificacao": {
      "idClassificacao": "",
      "dsClassificacao": "",
      "codClassificacao": "",
      "flAtivo": true
    },
    "irregularidade": {
      "idIrregularidade": 0,
      "nomeIrregularidade": "",
      "dsIrregularidade": "",
      "codIrregularidade": "",
      "flAtivo": true,
      "classificacao": {
        "idClassificacao": "",
        "dsClassificacao": "",
        "codClassificacao": "",
        "flAtivo": true
      },
      "assunto": {
        "idAssunto": 0,
        "codAssunto": "",
        "dsAssunto": "",
        "flAtivo": true
      },
      "subAssunto": {
        "idSubAssunto": 0,
        "codSubAssunto": "",
        "dsSubAssunto": "",
        "flAtivo": true
      },
      "legislacao": {
        "idLegislacao": 0,
        "dsLegislacao": "",
        "flAtivo": true
      },
      "modulo": {
        "idModuloPca": 0,
        "idModulo": 0,
        "codModulo": "",
        "dsModulo": "",
        "dsStatus": ""
      }
    },
    "responsaveis": [],
    "analise": [],
    "tbModuloPca": {
      "idModuloPca": 0
    },
    "tbModulo": {
      "idModulo": 0
    },
    "comentario": "",
    "cnpj": "",
    "vinculoCargo": "",
    "inicio": "",
    "fim": "",
    "empresaNome": "",
    "idEmpresa": 0
  };

  public getOcorrenciaVazia() {
    //this.ocorrencia = new Ocorrencia();
    //this.ocorrencia.getOcorrencia();
    return this.ocorrenciaVaziaJson;
  }

  public getOcorrencia(): Ocorrencia {
    return this.ocorrencia;
  }

  public obterOcorrencia(idOcorrencia): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/obter/" + idOcorrencia;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarOcorrenciasPorPCA(idPCA): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/listaPorPca/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarOcorrenciasPorModulo(idPCA, idModulo): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/listaPorPcaEModulo?idPca=" + idPCA + "&idModulo=" + idModulo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarOcorrenciasPorAnalise(idPCA, cdAnalise): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/listarPorAnalise?idPca=" + idPCA + "&cdTipoAnalise=" + cdAnalise;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarOcorrencia(jsonOcorrencia): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/salvar/";
    return this.utilService.postJSON(urlObtencaoDados, jsonOcorrencia);
  }

  public salvarPessoa(jsonPessoa): Observable<any> {
    let urlObtencaoDados: string = "ocorrenciapessoa/salvarPessoa/";
    return this.utilService.postJSON(urlObtencaoDados, jsonPessoa);
  }

  public deletarOcorrencia(idOcorrencia): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/deletar/" + idOcorrencia;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  /*================================================================
  *
  *  Ocorrência Pessoa
  *
  ==================================================================*/

  public listarPessoasOcorrencia(idOcorrencia): Observable<any> {
    let urlObtencaoDados: string = "ocorrenciapessoa/listarPessoas/" + idOcorrencia;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarResposaveisPorPCA(idPca): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarResponsaveisPorPca?idPca=" + idPca;
    return this.utilService.getJSON(urlObtencaoDados);
  }


    /*================================================================
  *
  *  Empresa
  *
  ==================================================================*/

  public obterEmpresaPorCnpj(cnpj): Observable<any> {
    let urlObtencaoDados: string = "empresa?cnpj=" + cnpj;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarEmpresa(empresa): Observable<any> {
    let urlObtencaoDados: string = "empresa/";
    return this.utilService.postJSON(urlObtencaoDados, empresa);
  }

  public listarEmpresas(): Observable<any> {
    let urlObtencaoDados: string = "empresa/";
    return this.utilService.getJSON(urlObtencaoDados);
  }
}



// WEBPACK FOOTER //
// ./src/providers/ocorrencias-service.ts